module.exports = __webpack_public_path__ + "img/miniflux.png";